"use strict";

var wordCount = require("../stringProcessing/countWords.js");
/**
 * Count the words in the text
 * @param {Paper} paper The Paper object who's
 * @returns {number} The amount of words found in the text.
 */
module.exports = function (paper) {
  return wordCount(paper.getText());
};
//# sourceMappingURL=wordCountInText.js.map
//# sourceMappingURL=wordCountInText.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/yoastseo/js/researches/wordCountInText.js
// module id = 346
// module chunks = 0